import React from 'react';
import PropTypes from 'prop-types';
import classes from 'components/SourceDisplay/SourceDisplay.module.scss';
import { FormattedMessage } from 'react-intl';
import AudioMonitor from '../../utils/AudioMonitor';

const micLevelLightCount = 17;

class MicrophoneLevel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      audioMonitorSuspended: false,
      micLevel: 0
    };
  }

  componentDidMount() {
    this.monitor = new AudioMonitor(
      value => this.onAudioMonitorUpdate(value),
      () => this.setState({ audioMonitorSuspended: true })
    );
    this.connectAudioMonitor();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.microphoneDeviceId !== this.props.microphoneDeviceId) {
      this.connectAudioMonitor();
    }
  }

  componentWillUnmount() {
    this.monitor.destroy();
  }

  onAudioMonitorUpdate(value) {
    const micLevel = (micLevelLightCount * value).toFixed(0);
    if (micLevel !== this.state.micLevel) {
      this.setState({ micLevel });
    }
  }

  micLevelLights() {
    const icons = new Array(micLevelLightCount);
    icons.fill(classes.off);
    if (!!this.props.microphoneDeviceId && this.props.microphoneEnabled) {
      icons.fill(classes.on, 0, this.state.micLevel);
    }
    return icons;
  }

  connectAudioMonitor() {
    if (this.props.microphoneDeviceId) {
      this.monitor.connect(this.props.microphoneDeviceId);
    }
    else {
      this.monitor.disconnect();
    }
  }

  initializeAudioMonitor = async () => {
    await this.monitor.audioContext.resume();
    this.setState({ audioMonitorSuspended: false });
  };

  renderMicrophoneLevels() {
    return (
      <div>
        <span className={classes.levelLabel}>
          <FormattedMessage
            id="components.avSettingsModal.levelLabel"
            defaultMessage="Microphone level"
          />
        </span>
        <span className={classes.audioBar}>
          {this.micLevelLights().map((lightState, index) => {
            const classList = [classes.audioSquare, lightState].join(' ');
            return <i key={index} className={classList} />;
          })}
        </span>
      </div>
    );
  }

  renderAudioInteraction() {
    return (
      <div className={classes.testContainer}>
        <button
          className={classes.testButton}
          onClick={this.initializeAudioMonitor}
        >
          <FormattedMessage
            id="components.avSettingsModal.testMicrophone"
            defaultMessage="Test my microphone"
          />
        </button>
      </div>
    );
  }

  render() {
    return (
      <div className={classes.audioContainer}>
        {this.state.audioMonitorSuspended ?
          this.renderAudioInteraction() :
          this.renderMicrophoneLevels()
        }
      </div>
    );
  }
}

MicrophoneLevel.propTypes = {
  microphoneDeviceId: PropTypes.string,
  microphoneEnabled: PropTypes.bool
};

export default MicrophoneLevel;
